/**
 * @param {Function} fn
 * @param {...*} args
 * @return {*}
 */
export function runIfExist(fn, ...args) {
  return fn && fn(...args);
}
